import { Dispatch, FC, SetStateAction, useMemo } from 'react'
import CustomToolTip from '../CustomToolTip'
import CustomDateTimeInput from '../datetime_input/CustomDateTimeInput'
import { AllFilterType } from './types'
import { showToastMessage } from '../../../utils/commonFunctions';

interface Props {
    applyFilter: (filters: AllFilterType) => void;
    allFilters: AllFilterType;
    setAllFilters: Dispatch<SetStateAction<AllFilterType>>;
    range?: {
        start: number;
        end: number
    }
}

const TimeInputFilter: FC<Props> = ({ allFilters, setAllFilters, applyFilter, range }) => {

    const startTime = useMemo(() => allFilters?.timeFilter?.startTime || null, [allFilters?.timeFilter?.startTime])
    const endTime = useMemo(() => allFilters?.timeFilter?.endTime || null, [allFilters?.timeFilter?.endTime])
    
    const onChange = (type: 'startTime' | 'endTime', dateTime: number | null) => {
        let updatedFilter: AllFilterType = {}
        setAllFilters((prev) => {
            const prevTimeFilter = prev?.timeFilter || { startTime: null, endTime: null };
            const currentTimeFilter = { ...prevTimeFilter, [type]: dateTime }
            const { startTime, endTime } = currentTimeFilter;

            const isSame =
                Object.keys(prevTimeFilter).length === Object.keys(currentTimeFilter).length &&
                Object.keys(prevTimeFilter).every((key) => prevTimeFilter[key] === currentTimeFilter[key]);
            if (isSame) {
                updatedFilter = {
                    ...prev,
                }
            } else if (startTime && endTime && (new Date(startTime).getTime() >= new Date(endTime).getTime())) {
                if (type === 'startTime') {
                    showToastMessage("error", "Start time must be less than End time");
                    updatedFilter = {
                        ...prev,
                        timeFilter: {
                            ...prevTimeFilter,
                            startTime: null,
                        },
                    }
                } else if (type === 'endTime') {
                    showToastMessage('error', 'End time must be greater than Start Time');
                    updatedFilter = {
                        ...prev,
                        timeFilter: {
                            ...prevTimeFilter,
                            endTime: null,
                        },
                    }
                }
                applyFilter(updatedFilter)
            } else {
                updatedFilter = {
                    ...prev,
                    timeFilter: {
                        ...prevTimeFilter,
                        [type]: dateTime,
                    },
                }
                applyFilter(updatedFilter)
            }
            return updatedFilter
        });
    };


    return (
        <div className="d-flex align-items-center gap-1">
            <CustomToolTip title={"Start Time"} placement="top">
                <CustomDateTimeInput key="startTime" range={range} dateTime={startTime} setDateTime={(dateTime) => { onChange('startTime', dateTime) }} type={'startTime'}/>
            </CustomToolTip>
            <div> &nbsp;-&nbsp; </div>
            <CustomToolTip title={"End Time"} placement="top">
                <CustomDateTimeInput key="endTime" range={range} dateTime={endTime} setDateTime={(dateTime) => { onChange('endTime', dateTime) }} type={'endTime'} />
            </CustomToolTip>
        </div>
    )
}

export default TimeInputFilter